import React, { useState, useCallback, useRef } from "react";
// import "react-simple-keyboard/build/css/index.css";
import 'react-simple-keyboard/build/css/index.css';
import {SimpleKeyboard} from "react-simple-keyboard";
import Keyboard from "react-simple-keyboard";


interface VirtualKeyboardProps {
  keyboardRef: (r: SimpleKeyboard) => void;
  onChange: (input: string) => void;
  show?: boolean;
  onShowChange?: (show: boolean) => void;
  inModal: boolean;
}

const DEFAULT_LAYOUT = "default";
const SHIFT_LAYOUT = "shift";

const VirtualKeyboard: React.FC<VirtualKeyboardProps> = ({
  
  onChange,
  keyboardRef,
  show: controlledShow,
  onShowChange,
  inModal = false, // Default to true for backward compatibility
}) => {
  const [layoutName, setLayoutName] = useState<string>(DEFAULT_LAYOUT);
  const [uncontrolledShow, setUncontrolledShow] = useState(false);
  const show = controlledShow !== undefined ? controlledShow : uncontrolledShow;
  const target = useRef(null);
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  const [keyboardPos, setKeyboardPos] = useState<{top: number, left: number} | null>(null);

  const handleShift = useCallback(() => {
    setLayoutName(prev => (prev === DEFAULT_LAYOUT ? SHIFT_LAYOUT : DEFAULT_LAYOUT));
  }, []);

  const onKeyPress = useCallback((button: string) => {
    console.log("Button pressed", button);
    if (button === "{shift}" || button === "{lock}") handleShift();
  }, [handleShift]);

  const handleButtonClick = () => {
    if (onShowChange) {
      onShowChange(!show);
    } else {
      setUncontrolledShow(!show);
    }
    // Calculate position for keyboard below the button
    if (buttonRef.current && !show) {
      const rect = buttonRef.current.getBoundingClientRect();
      setKeyboardPos({
        top: rect.bottom + window.scrollY + 4, // 4px gap
        left: rect.left + window.scrollX
      });
    }
  };

  return (
    <>
      <span ref={target} style={{ display: 'inline-block' }}>
        <button
          ref={buttonRef}
          type="button"
          aria-label="Show Keyboard"
          style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4, display: 'flex', alignItems: 'center', height: '100%' }}
          onClick={handleButtonClick}
          tabIndex={0}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="5" width="20" height="14" rx="2" /><path d="M6 10h.01M10 10h.01M14 10h.01M18 10h.01M6 14h.01M10 14h4M18 14h.01" /></svg>
        </button>
      </span>
      {!inModal && keyboardPos && show && 
        <div
          style={{
            position: 'absolute',
            top: keyboardPos.top,
            left: keyboardPos.left-225,
            zIndex: 1050,
            background: 'white',
            border: '1px solid #ddd',
            borderRadius: 4,
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            width: 450,
          }}
        >
          <Keyboard
            keyboardRef={keyboardRef}
            layoutName={layoutName}
            onChange={onChange}
            onKeyPress={onKeyPress}
            onRender={() => console.log("Rendered")}
          />
        </div> 
        }
      {/* } */}
      {inModal && show && keyboardPos &&
     <div
        style={{
          position: 'relative', // relative to modal content
          width: '0%',
          height: 0, // so it doesn't take up space
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: 50, // position relative to modal
            right: 0,
            zIndex: 1050,
            background: 'white',
            border: '1px solid #ddd',
            borderRadius: 4,
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            width: 450,
          }}
        >
          <Keyboard
            keyboardRef={keyboardRef}
            layoutName={layoutName}
            onChange={onChange}
            onKeyPress={onKeyPress}
            onRender={() => console.log("Rendered")}
          />
        </div>
      </div>
          }
    </>
  );
};

export default VirtualKeyboard;
